module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/level-6_start-8857fd7956f4a93c8ecdb7030558b053.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/level-6_start.png
// module id = 911
// module chunks = 2